import { Component } from '@angular/core';
import { MainNavigationComponent } from './components/main-navigation/main-navigation.component';

@Component({
  selector: 'peca-root',
  template: `<peca-main-navigation />`,
  imports: [MainNavigationComponent],
})
export class AppComponent {}
